import React, { useState, useEffect } from 'react';
import swal from 'sweetalert';
import Dropdown from 'react-bootstrap/Dropdown';
import ActionConfigModal, { renderActionConfigDetails } from './ActionConfigModal';
import { toast } from 'react-toastify';
import { DYNAMIC_TABLE, GENERIC_REQUEST, WORKFLOW, GENERIC_DATA_CREATE, getApiPath, LIST, VIEW, ADD_UPDATE, UPDATE } from '../../../api/ApiConst';
import ApiCaller from '../../../api/ApiCaller';
const actionTypes = [
    { id: 'INSERT', label: 'Insert', icon: 'fa-solid fa-plus' },
    { id: 'UPDATE', label: 'Update', icon: 'fa-solid fa-pen-to-square' },
    { id: 'DELETE', label: 'Delete', icon: 'fa-solid fa-trash' },
    { id: 'CALL_API', label: 'Call API', icon: 'fa-solid fa-link' },
    { id: 'SEND_EMAIL', label: 'Send Email', icon: 'fa-solid fa-envelope' },
    { id: 'CONDITION', label: 'Condition', icon: 'fa-solid fa-check-circle' },
    { id: 'AGGREGATION', label: 'Aggregation', icon: 'fa-solid fa-chart-line' },
    { id: 'MERGE', label: 'Merge', icon: 'fa-solid fa-object-group' },
    { id: 'RESPONSE_FORMAT', label: 'Response Format', icon: 'fa-solid fa-file-code' },
];

const WorkflowBuilder = () => {
    const [workflowName, setWorkflowName] = useState('');
    const [selectedRequest, setSelectedRequest] = useState('');
    const [steps, setSteps] = useState([]);
    const [draggedStepIndex, setDraggedStepIndex] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [currentStepId, setCurrentStepId] = useState(null);
    const [currentAction, setCurrentAction] = useState(null);
    const [customRequestList, setCustomRequestList] = useState([]);
    const [allTableList, setAllTableList] = useState([]);
    const [showStepDetails, setShowStepDetails] = useState(null);
    const [workflowId, setWorkflowId] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        // Extract workflowId from URL
        const url = new URL(window.location.href);
        const pathSegments = url.pathname.split('/').filter(segment => segment.trim() !== '');
        const extractedWorkflowId = pathSegments[pathSegments.length - 1];
        
        console.log('URL path segments:', pathSegments);
        console.log('Extracted workflow ID:', extractedWorkflowId);
        
        if (extractedWorkflowId && extractedWorkflowId !== 'new' && extractedWorkflowId !== 'workflows') {
            setWorkflowId(extractedWorkflowId);
            setIsEditing(true);
            loadExistingWorkflow(extractedWorkflowId);
        } else {
            console.log('No valid workflow ID found, creating new workflow');
        }
        
        fetchAllTableList();
        fetchCustomRequestList();
    }, []);

    const fetchAllTableList = () => {
        var jsonRequest = {
            "page": 0,
            "size": 1000,
            searchFilters: [],
            sortRules: [],
        };
        const url = getApiPath(DYNAMIC_TABLE, LIST);
        ApiCaller.callPostApi(url, jsonRequest, {}, (response) => {
            setAllTableList(response?.data || []);
        }, (error) => {
            console.error(error);
            setAllTableList([]);
        })
    }

    const loadExistingWorkflow = (id) => {
        setLoading(true);
        const url = getApiPath(WORKFLOW, VIEW, id);
        console.log('Loading workflow from URL:', url);
        
        ApiCaller.callGetApi(url, {}, (response) => {
            console.log('Loaded existing workflow:', response);
            
            try {
                // Set workflow name
                setWorkflowName(response.name || '');
                
                // Set selected request
                setSelectedRequest(response.customRequestId || '');
                
                // Set steps with proper structure
                if (response.steps && Array.isArray(response.steps)) {
                    const formattedSteps = response.steps.map((step, index) => {
                        console.log(`Step ${index + 1} data:`, step);
                        console.log(`Step ${index + 1} step.type:`, step.type);
                        console.log(`Step ${index + 1} step.action:`, step.action);
                        console.log(`Step ${index + 1} step.config:`, step.config);
                        
                        // Handle the new structure where step has a type field
                        let actionType = null;
                        
                        // Check for the new structure first (step.type)
                        if (step.type && typeof step.type === 'string' && ['INSERT', 'UPDATE', 'DELETE', 'CALL_API', 'SEND_EMAIL', 'CONDITION', 'AGGREGATION', 'MERGE', 'RESPONSE_FORMAT'].includes(step.type)) {
                            actionType = step.type;
                            console.log(`Step ${index + 1} using step.type:`, actionType);
                        } 
                        // Check for old structure (step.action.id)
                        else if (step.action && step.action.id && typeof step.action.id === 'string' && ['INSERT', 'UPDATE', 'DELETE', 'CALL_API', 'SEND_EMAIL', 'CONDITION', 'AGGREGATION', 'MERGE', 'RESPONSE_FORMAT'].includes(step.action.id)) {
                            actionType = step.action.id;
                            console.log(`Step ${index + 1} using step.action.id:`, actionType);
                        } 
                        // Check for old structure (step.action.type)
                        else if (step.action && step.action.type && typeof step.action.type === 'string' && ['INSERT', 'UPDATE', 'DELETE', 'CALL_API', 'SEND_EMAIL', 'CONDITION', 'AGGREGATION', 'MERGE', 'RESPONSE_FORMAT'].includes(step.action.type)) {
                            actionType = step.action.type;
                            console.log(`Step ${index + 1} using step.action.type:`, actionType);
                        } 
                        // Check for config structure
                        else if (step.config && step.config.actionType && typeof step.config.actionType === 'string' && ['INSERT', 'UPDATE', 'DELETE', 'CALL_API', 'SEND_EMAIL', 'CONDITION', 'AGGREGATION', 'MERGE', 'RESPONSE_FORMAT'].includes(step.config.actionType)) {
                            actionType = step.config.actionType;
                            console.log(`Step ${index + 1} using step.config.actionType:`, actionType);
                        }
                        // Check for config.type
                        else if (step.config && step.config.type && typeof step.config.type === 'string' && ['INSERT', 'UPDATE', 'DELETE', 'CALL_API', 'SEND_EMAIL', 'CONDITION', 'AGGREGATION', 'MERGE', 'RESPONSE_FORMAT'].includes(step.config.type)) {
                            actionType = step.config.type;
                            console.log(`Step ${index + 1} using step.config.type:`, actionType);
                        }
                        // If still no valid action type found, use default
                        else {
                            console.warn(`No valid action type found for step ${index + 1}, using default INSERT`);
                            console.warn(`Step ${index + 1} available data:`, {
                                stepType: step.type,
                                stepAction: step.action,
                                stepConfig: step.config
                            });
                            actionType = 'INSERT'; // Default fallback
                        }
                        
                        console.log(`Step ${index + 1} determined action type:`, actionType);
                        
                        // Create the action object based on the new structure
                        const action = {
                            id: actionType,
                            type: actionType,
                            label: actionType, // Use the type as label
                            config: step.config || step.action?.config || step.action?.parameters || {}
                        };
                        
                        return {
                            id: step.id || index + 1,
                            actions: [action]
                        };
                    });
                    console.log('Formatted steps:', formattedSteps);
                    setSteps(formattedSteps);
                } else {
                    console.log('No steps found in response or steps is not an array');
                    setSteps([]);
                }
            } catch (error) {
                console.error('Error processing workflow data:', error);
                toast.error('Error processing workflow data');
            }
            
            setLoading(false);
        }, (error) => {
            console.error('Error loading workflow:', error);
            toast.error('Failed to load workflow data');
            setLoading(false);
        });
    };
    const reindexSteps = (stepList) =>
        stepList.map((step, index) => ({
            ...step,
            id: index + 1,
        }));

    const addStep = () => {
        const newStep = { id: steps.length + 1, actions: [] };
        setSteps((prevSteps) => reindexSteps([...prevSteps, newStep]));
    };

    const insertStepAt = (index) => {
        const newStep = { id: steps.length + 1, actions: [] };
        const newSteps = [...steps];
        newSteps.splice(index + 1, 0, newStep);
        const reindexedSteps = newSteps.map((step, idx) => ({
            ...step,
            id: idx + 1
        }));
        setSteps(reindexedSteps);
    };

    const handleDropAction = (stepId, actionData) => {
        if (steps.find((s) => s.id === stepId)?.actions.length) return;
        const actionDataObj = JSON.parse(actionData);
        
        // Transform the action data to match the expected structure
        const action = {
            type: actionDataObj.id, // Convert 'id' to 'type'
            id: actionDataObj.id,
            label: actionDataObj.label,
            icon: actionDataObj.icon
        };
        
        setCurrentStepId(stepId);
        setCurrentAction(action);
        setShowModal(true);
    };
      
    const handleModalSave = (configuredAction) => {
        console.log('handleModalSave - configuredAction:', configuredAction);
        
        const updatedSteps = steps.map((step) =>
            step.id === currentStepId
                ? { ...step, actions: [configuredAction] } // only one action per step
                : step
        );
        setSteps(reindexSteps(updatedSteps));
        setShowModal(false);
        setCurrentAction(null);
        setCurrentStepId(null);
    };

    const removeActionFromStep = (stepId, actionIndex) => {
        const updatedSteps = steps.map((step) =>
            step.id === stepId
                ? { ...step, actions: step.actions.filter((_, idx) => idx !== actionIndex) }
                : step
        );
        setSteps(reindexSteps(updatedSteps));
    };

    const reorderSteps = (fromIndex, toIndex) => {
        if (fromIndex === toIndex) return;
        const updatedSteps = [...steps];
        const [moved] = updatedSteps.splice(fromIndex, 1);
        updatedSteps.splice(toIndex, 0, moved);
        setSteps(reindexSteps(updatedSteps));
    };

    const removeStep = (index) => {
        let responseParametersUsed = false;
        let responseParametersUsedStepId = null;

        for (let i = 0; i < steps.length; i++) {
            for (let j = 0; j < steps[i].actions.length; j++) {
                const action = steps[i].actions[j];
                if (action.config?.requestParamSource?.includes(steps[index]?.id)) {
                    responseParametersUsed = true;
                    responseParametersUsedStepId = i;
                    break;
                }
            }
        
            if (responseParametersUsed) {
                break;
            }
        }
        
        if(responseParametersUsed){
            toast.error(`Response parameters used in step ${responseParametersUsedStepId +1}, remove that first`);
            return;
        }
        swal({
            title: "Are you sure?",
            buttons: {
                cancel: true,
                confirm: true,
            },
            text: "Are you sure that you want to remove this step?",
            icon: "warning",
            dangerMode: true,
        }).then((result) => {
            if (result) {
                const updatedSteps = [...steps];
                updatedSteps.splice(index, 1);
                setSteps(reindexSteps(updatedSteps));
            }
        })
    };

    const saveWorkflow = () => {
        if(workflowName?.trim() === ''){
            toast.error('Please enter workflow name');
            return;
        }
        
        // Validate that all steps have actions
        const stepsWithoutActions = steps.filter(step => !step.actions || step.actions.length === 0);
        if(stepsWithoutActions.length > 0) {
            toast.error('Please configure all steps before saving');
            return;
        }

        const payload = {
            name: workflowName,
            customRequestId: selectedRequest,
            steps: steps.map((step) => ({
                id: step.id,
                type: step.actions?.[0]?.type || step.actions?.[0]?.id,
                config: step.actions?.[0]?.config || {},
                resultAs: step.actions?.[0]?.config?.resultAs || '',
                responseParameters: step.actions?.[0]?.config?.responseParameters || [],
                requestParamSource: step.actions?.[0]?.config?.requestParamSource || []
            })),
        };
        
        console.log("Saving workflow with payload:", payload);
        
        let url;
        if (isEditing && workflowId) {
            // Update existing workflow
            url = getApiPath(WORKFLOW, UPDATE, workflowId);
            console.log('Updating workflow at URL:', url);
        } else {
            // Create new workflow
            url = getApiPath(WORKFLOW, GENERIC_DATA_CREATE);
            console.log('Creating workflow at URL:', url);
        }
        
        ApiCaller.callPostApi(url, payload, {}, (response) => {
            console.log('Workflow saved successfully:', response);
            toast.success(isEditing ? 'Workflow updated successfully!' : 'Workflow saved successfully!');
            
            if (!isEditing) {
                // Reset form after successful save only for new workflows
                setWorkflowName('');
                setSelectedRequest('');
                setSteps([]);
            }
        }, (error) => {
            console.error('Error saving workflow:', error);
            const errorMessage = error?.response?.data?.message || `Failed to ${isEditing ? 'update' : 'save'} workflow`;
            toast.error(errorMessage);
        });
    };

    const fetchCustomRequestList = () => {
        var jsonRequest = {
            "page": 0,
            "size": 1000,
            searchFilters: [],
            sortRules: [],
        };
        const url = getApiPath(GENERIC_REQUEST, LIST);
        ApiCaller.callPostApi(url, jsonRequest, {}, (response) => {
            setCustomRequestList(response?.data || []);
        }, (error) => {
            console.error(error);
            setCustomRequestList([]);
        })
    }
    
    const isDisabled = !selectedRequest;

    const renderStepContent = (step) => {
        const action = step.actions[0];
        if (!action) return null;

        const tableName = action.config?.tableId 
            ? allTableList.find(t => t.id === action.config.tableId)?.name 
            : null;

        return (
            <div className="step-content">
                <div className="step-header d-flex justify-content-between align-items-center">
                    <strong>Step {step.id}</strong>
                    <Dropdown>
                        <Dropdown.Toggle
                            bsPrefix="m-0"
                            style={{ 
                                fontSize: '20px', 
                                lineHeight: '1', 
                                color: 'black', 
                                backgroundColor: 'transparent', 
                                border: 'none',
                                padding: "4px 10px"
                            }}
                            id={`dropdown-step-${step.id}`}
                        >
                            ⋮
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item key={`view-${step.id}`} onClick={() => setShowStepDetails(step.id)}>
                                View Details
                            </Dropdown.Item>
                            <Dropdown.Item key={`edit-${step.id}`} onClick={() => {
                                console.log('Edit button clicked for step:', step.id);
                                console.log('Action data:', action);
                                setCurrentStepId(step.id);
                                setCurrentAction(action);
                                setShowModal(true);
                            }}>
                                Edit
                            </Dropdown.Item>
                            <Dropdown.Item
                                key={`remove-action-${step.id}`}
                                onClick={() => removeActionFromStep(step.id, 0)}
                                className="text-warning"
                            >
                                Remove Action
                            </Dropdown.Item>
                            <Dropdown.Item
                                key={`remove-step-${step.id}`}
                                onClick={() => removeStep(steps.findIndex(s => s.id === step.id))}
                                className="text-danger"
                            >
                                Remove Step
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                <div className="step-info">
                    <div className="info-row">
                        <span className="label">Action:</span>
                        <span className="value">{action.label}</span>
                    </div>
                    {tableName && (
                        <div className="info-row">
                            <span className="label">Table:</span>
                            <span className="value">{tableName}</span>
                        </div>
                    )}
                </div>
            </div>
        );
    };

    const renderConditionalSteps = (step) => {
        const action = step.actions[0];
        if (!action || action.id !== 'CONDITION') return null;

        const trueStep = steps.find(s => s.id === action.config?.conditionalSteps?.[0]?.stepId);
        const falseStep = steps.find(s => s.id === action.config?.elseStepId);

        return (
            <div className="conditional-branches">
                <div className="branches-container">
                    <div className="branch true-branch">
                        <div className="branch-header">
                            <div className="branch-arrow">
                                <div className="arrow-line"></div>
                                <div className="arrow-label">True</div>
                            </div>
                        </div>
                    </div>
                    <div className="branch false-branch">
                        <div className="branch-header">
                            <div className="branch-arrow">
                                <div className="arrow-line"></div>
                                <div className="arrow-label">False</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="branch-steps-container">
                    <div className="branch-steps">
                        {trueStep && (
                            <div className="step-wrapper">
                                <div className="step-container">
                                    {renderStepContent(trueStep)}
                                </div>
                            </div>
                        )}
                        {falseStep && (
                            <div className="step-wrapper">
                                <div className="step-container">
                                    {renderStepContent(falseStep)}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    };

    const renderSteps = () => {
        const renderedSteps = [];
        let i = 0;
        
        while (i < steps.length) {
            const step = steps[i];
            const index = i; // capture stable index for handlers
            const action = step.actions[0];
            
            if (action?.id === 'CONDITION') {
                // For condition step, render it and its branches
                renderedSteps.push(
                    <div key={step.id} className="step-wrapper">
                        <div className="d-flex justify-content-center align-items-center">
                            {index > 0 && (
                                <button
                                    className="insert-step-btn"
                                    onClick={() => {
                                        if (!isDisabled) {
                                            const newStep = { id: steps.length + 1, actions: [] };
                                            const newSteps = [...steps];
                                            // Button is rendered above current step, so insert at current index
                                            newSteps.splice(index, 0, newStep);
                                            setSteps(newSteps.map((step, idx) => ({
                                                ...step,
                                                id: idx + 1
                                            })));
                                        }
                                    }}
                                    title="Add step between"
                                    disabled={isDisabled}
                                >
                                    <span className="arrow-icon">↓</span>
                                    <span className="plus-icon">+</span>
                                </button>
                            )}
                        </div>
                        <div
                            onDragStart={() => {
                                setDraggedStepIndex(index);
                            }}
                            onDragOver={(e) => e.preventDefault()}
                            onDrop={() => {
                                if (!isDisabled && draggedStepIndex !== null) {
                                    reorderSteps(draggedStepIndex, index);
                                    setDraggedStepIndex(null);
                                }
                            }}
                            onDropCapture={(e) => {
                                if (e.dataTransfer.getData('action')) {
                                    handleDropAction(step.id, e.dataTransfer.getData('action'));
                                }
                            }}
                            onDragEnd={() => {
                                setDraggedStepIndex(null);
                            }}
                            className={`step-container ${draggedStepIndex === index ? 'dragged' : ''}`}
                        >
                            {renderStepContent(step)}
                        </div>
                        {renderConditionalSteps(step)}
                    </div>
                );
                i++;
            } else {
                // For regular steps
                renderedSteps.push(
                    <div key={step.id} className="step-wrapper">
                        <div className="d-flex justify-content-center align-items-center">
                            {index > 0 && (
                                <button
                                    className="insert-step-btn"
                                    onClick={() => {
                                        if (!isDisabled) {
                                            const newStep = { id: steps.length + 1, actions: [] };
                                            const newSteps = [...steps];
                                            // Button is rendered above current step, so insert at current index
                                            newSteps.splice(index, 0, newStep);
                                            setSteps(newSteps.map((step, idx) => ({
                                                ...step,
                                                id: idx + 1
                                            })));
                                        }
                                    }}
                                    title="Add step between"
                                    disabled={isDisabled}
                                >
                                    <span className="arrow-icon">↓</span>
                                    <span className="plus-icon">+</span>
                                </button>
                            )}
                        </div>
                        <div
                            onDragStart={() => {
                                setDraggedStepIndex(index);
                            }}
                            onDragOver={(e) => e.preventDefault()}
                            onDrop={() => {
                                if (!isDisabled && draggedStepIndex !== null) {
                                    reorderSteps(draggedStepIndex, index);
                                    setDraggedStepIndex(null);
                                }
                            }}
                            onDropCapture={(e) => {
                                if (e.dataTransfer.getData('action')) {
                                    handleDropAction(step.id, e.dataTransfer.getData('action'));
                                }
                            }}
                            onDragEnd={() => {
                                setDraggedStepIndex(null);
                            }}
                            className={`step-container ${draggedStepIndex === index ? 'dragged' : ''}`}
                        >
                            {step.actions.length > 0 ? (
                                renderStepContent(step)
                            ) : (
                                <div className="text-center text-primary">
                                    + Add Action Here
                                    <div className="mt-2">
                                        <button
                                            type="button"
                                            className="btn btn-outline-danger btn-sm"
                                            onClick={() => removeStep(steps.findIndex(s => s.id === step.id))}
                                        >
                                            Remove Step
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                );
                i++;
            }
        }
        
        return renderedSteps;
    };

    return (
        <div className="workflow-builder" style={{ padding: '20px', height: '100vh', display: 'flex', flexDirection: 'column' }}>
            {loading && (
                <div className="loading-overlay" style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(255, 255, 255, 0.8)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 1000
                }}>
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            )}

            <div className="d-flex justify-content-between align-items-center mb-4">
                <h3>{isEditing ? 'Edit Workflow' : 'Create New Workflow'}</h3>
                <button
                    onClick={saveWorkflow}
                    disabled={isDisabled || steps.length === 0 || loading}
                    className="btn btn-primary"
                    style={{ height: '38px', alignSelf: 'flex-end' }}
                >
                    {loading ? (
                        <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Loading...
                        </>
                    ) : (
                        isEditing ? 'Update Workflow' : 'Save Workflow'
                    )}
                </button>
            </div>

            <div 
                className="d-flex justify-content-between align-items-center mb-4 bg-white p-3 rounded" 
                style={{ gap: '20px', flexWrap: 'wrap', border: '1px solid rgb(227, 227, 227)' }}>
                <div className='d-flex justify-content-between align-items-center w-60 gap-5'>
                    <div>
                        <label htmlFor="workflowName" style={{ display: 'block', marginBottom: '5px' }}>
                            Workflow Name:
                        </label>
                        <input
                            id="workflowName"
                            type="text"
                            value={workflowName}
                            onChange={(e) => setWorkflowName(e.target.value)}
                            placeholder="Enter workflow name"
                            style={{ padding: '6px', width: '250px' }}
                            disabled={loading}
                        />
                    </div>
                    <div>
                        <label htmlFor="customRequestSelect" style={{ display: 'block', marginBottom: '5px' }}>
                            Select Custom Request:
                        </label>
                        <select
                            id="customRequestSelect"
                            value={selectedRequest}
                            onChange={(e) => {
                                const selected = e.target.value;
                                setSelectedRequest(selected);
                                if (!isEditing) {
                                    setSteps([{ id: 1, actions: [] }]);
                                }
                            }}
                            style={{ padding: '6px', width: '250px' }}
                            disabled={loading}
                        >
                            <option value="">Select Custom Request</option>
                            {customRequestList.map((req) => (
                                <option key={req.id} value={req.id}>
                                    {req.name}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>

            <div className="workflow-layout" style={{ display: 'flex', gap: '20px', height: "calc(100% - 200px)", overflowY: "hidden" }}>
                {/* Left Panel */}
                <div className="left-panel smallScrollbar" style={{ flex: 1, position: 'relative', overflowY: "auto", height: "100%" }}>
                    <div className="d-flex flex-column align-items-center">
                        {renderSteps()}
                        {isDisabled ? (
                            <div className="mt-3" style={{ textAlign: 'center' }}>
                                Please select a custom request to start building the workflow.
                            </div>
                        ) : (
                            <button 
                                onClick={addStep} 
                                className="btn btn-primary mt-3"
                                disabled={isDisabled || (steps?.length > 0 && steps?.[steps?.length - 1]?.actions?.length === 0) || loading}
                            >
                                + Add Step
                            </button>
                        )}
                    </div>
                </div>

                {/* Right Panel */}
                <div className="right-panel smallScrollbar" style={{ overflowY: "auto", height: "100%" }}>
                    <div className="actions-container">
                        <h5 className='mb-3'>Available Actions</h5>
                        <div className="d-flex flex-wrap justify-content-between align-items-center" style={{ gap: "10px 0" }}>
                            {actionTypes.map((action) => (
                                <div
                                    key={action.id}
                                    draggable={!isDisabled && !loading}
                                    onDragStart={(e) => e.dataTransfer.setData('action', JSON.stringify(action))}
                                    style={{
                                        padding: '10px',
                                        background: '#fff',
                                        border: "1px solid #cacaca",
                                        borderRadius: '4px',
                                        cursor: (isDisabled || loading) ? 'not-allowed' : 'grab',
                                        opacity: (isDisabled || loading) ? 0.5 : 1,
                                        width: "100%"
                                    }}
                                >
                                    <i className={`${action.icon} me-2`}></i>  {action.label}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {showModal && (
                <ActionConfigModal
                    show={showModal}
                    action={currentAction}
                    onSave={handleModalSave}
                    onClose={() => setShowModal(false)}
                    allTableList={allTableList}
                    selectedRequest={selectedRequest}
                    allSteps={steps}
                    currentStepId={currentStepId}
                />
            )}

            {showStepDetails && (
                <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Step Details</h5>
                                <button type="button" className="btn-close" onClick={() => setShowStepDetails(null)}></button>
                            </div>
                            <div className="modal-body">
                                {renderActionConfigDetails(steps.find(s => s.id === showStepDetails)?.actions[0], allTableList)}
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
};

export default WorkflowBuilder;
